// extracted by mini-css-extract-plugin
export default {"pageRoot":"StoreProfilePage_pageRoot__v1s5h","mainContent":"StoreProfilePage_mainContent__-wGbc"};